"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthFacilityUpdateDto = void 0;
const health_facility_1 = require("../health.facility");
const misc_1 = require("../../../misc");
class HealthFacilityUpdateDto extends (0, misc_1.generateUpdateDto)(health_facility_1.HealthFacility, ['name', 'address', 'type', 'visitFeePercentage', 'iban']) {
}
exports.HealthFacilityUpdateDto = HealthFacilityUpdateDto;
